import { v4 as uuidv4 } from "uuid";

const generateId = () => {
  return uuidv4();
};

const generateMessageId = () => {
  return generateId();
};

const isTokenExpired = (token) => {
  let decodedToken = parseJwt(token);
  if (Date.now() >= decodedToken.exp * 1000) {
    return true;
  }
};

function parseJwt(token) {
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  let jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

function formateDateTime(dateParam) {
  if (!dateParam) {
    return null;
  }
  const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);

  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  const hours = date.getHours();
  let minutes = date.getMinutes();

  if (minutes < 10) {
    // Adding leading zero to minutes
    minutes = `0${minutes}`;
  }
  const today = new Date();
  const isToday = today.toDateString() === date.toDateString();
  const isNow = today.getMinutes() <= date.getMinutes() + 1 && today.getHours() === date.getHours() && today.getMonth() === date.getMonth() ;
  if (isToday && isNow) {
    return `Just now`;
  }
  if (isToday) {
    // Today
    return `Today at ${hours}:${minutes}`;
  }
  return `${day}. ${month} ${year}. at ${hours}:${minutes}`;
}
function numDifferentiation(value) {
  let val = Math.abs(value)
  if (val >= 10000000) {
    if (val % 10000000 === 0) {
      val = `${(val / 10000000).toFixed(0)}Cr`;
    }
    else {
      val = `${(val / 10000000).toFixed(1)}Cr `;
    }
  } else if (val >= 100000) {
    if (val % 100000 === 0) {
      val = `${(val / 100000).toFixed(0)}L`
    }
    else {
      val = `${(val / 100000).toFixed(1)}L`;
    }

  }
  else{
    val = val.toLocaleString()
  }
  return val;
}


export { generateId, generateMessageId, isTokenExpired, formateDateTime, numDifferentiation };
